import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ValidatorMessenger}                  from '../Service/ValidatorMessenger';


@Component({
    selector     : 'validation-messages',
    template     : `
        <div class="validation-messages-container">
            <div class="alert alert-danger validation-messages" [hidden]="!errors">
                <ul>
                    <li *ngFor="let key of getKeys()">{{getMessage(key)}}</li>
                </ul>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styles: [`@-webkit-keyframes shake{10%,90%{-webkit-transform:translate3d(-1px,0,0);transform:translate3d(-1px,0,0)}20%,80%{-webkit-transform:translate3d(2px,0,0);transform:translate3d(2px,0,0)}30%,50%,70%{-webkit-transform:translate3d(-4px,0,0);transform:translate3d(-4px,0,0)}40%,60%{-webkit-transform:translate3d(4px,0,0);transform:translate3d(4px,0,0)}}@keyframes shake{10%,90%{-webkit-transform:translate3d(-1px,0,0);transform:translate3d(-1px,0,0)}20%,80%{-webkit-transform:translate3d(2px,0,0);transform:translate3d(2px,0,0)}30%,50%,70%{-webkit-transform:translate3d(-4px,0,0);transform:translate3d(-4px,0,0)}40%,60%{-webkit-transform:translate3d(4px,0,0);transform:translate3d(4px,0,0)}}.validation-messages-container{position:relative;width:100%;display:block}.validation-messages-container .alert{position:absolute;bottom:24px;-webkit-box-shadow:2px 2px 5px 0 rgba(0,0,0,.2);box-shadow:2px 2px 5px 0 rgba(0,0,0,.2);width:auto;padding:5px 10px;max-width:100%;-webkit-animation:.5s cubic-bezier(.36,.07,.19,.97) both shake;animation:.5s cubic-bezier(.36,.07,.19,.97) both shake;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);cursor:pointer;font-size:.8em}@media (max-width:600px){.validation-messages-container .alert{font-size:.9em}}.validation-messages-container .alert.dismissed{display:none}.validation-messages-container .alert ul{list-style:none;margin:0;padding:0}.validation-messages-container .alert ul li{margin:0}`]
})
export class ValidationMessagesComponent {
    @Input() errors: { [key: string]: boolean };
    @Input() label: string = '';


    constructor(public messenger: ValidatorMessenger) {

    }

    getKeys() {
        if (!this.errors) {
            return [];
        }
        return Object.keys(this.errors);
    }

    getMessage(key) {
        return this.messenger.getMessageForError(this.errors, key, this.label);
    }

    getErrorMessages() {

    }
}
